.input-group{border:1px solid #e2e2e2;border-radius:4px;padding:1px}.input-group .form-control{border:none}.input-group .separator{border:1px solid #e2e2e2;margin:5px}.input-group .btn{border-radius:2px!important}
/*# sourceMappingURL=input.duration-BD27UT2G.css.map */
